<div class="info-container" [class.small-container]="enableResponsive" resize-aware (currentSize)="adaptToSize($event)">
    <div class="left-container">
        <div class="icon-container"><ng-content select="[cui-info-card-icon]"></ng-content></div>
        <ng-container *ngIf="enableResponsive">
            <ng-container *ngTemplateOutlet="title"></ng-container>
        </ng-container>
        <ng-content select="cui-info-card-status"></ng-content>
    </div>
    <div class="content-container" [class.with-under-content]="underContent">
        <div class="left-col">
            <ng-container *ngIf="!enableResponsive">
                <ng-container *ngTemplateOutlet="title"></ng-container>
            </ng-container>
            <ng-content select="cui-info-card-left-content"></ng-content>
        </div>
        <div class="right-col">
            <ng-content select="cui-info-card-right-content"></ng-content>
        </div>
        <div class="under" *ngIf="underContent">
            <ng-content select="cui-info-card-under-content"></ng-content>
        </div>
    </div>
</div>
<ng-template #title>
    <p class="info-card-title"><ng-content select="cui-info-card-title"></ng-content></p>
</ng-template>
